import React, { useEffect, useLayoutEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { redirectUserToHomePageAfterRegistration } from "@utils";
import { MobilePlatform } from "@state/stores/types";
import { useRootAppStore } from "@hooks";
import useDynamicMinHeight from "@hooks/useDynamicMinHeight ";
import { OnBoardingSlider } from "../shared";
import { useScrollRestoration } from "@hooks/useScrollRestoration";
import { ConfigType } from "@data-types/use-scroll-restoration/useScrollRestoration";

export default function RegistrationSuccess() {
	const { pageStore } = useRootAppStore<MobilePlatform>();
	const { t } = useTranslation("registration");
	const cardFormRef = useRef<HTMLDivElement>(null);

	const headerPlusSliderHeight = 180 + 96;

	const minHeight = useDynamicMinHeight(headerPlusSliderHeight);

	useScrollRestoration({ type: ConfigType.Basic });

	useLayoutEffect(() => {
		pageStore.setMinimalPageHeader();
	}, []);

	useEffect(() => {
		if (cardFormRef.current) {
			cardFormRef.current.style.minHeight =
				minHeight !== undefined ? `${minHeight}px` : "auto";
		}
	}, [minHeight]);

	return (
		<div className="container">
			<div className="section--membership">
				<OnBoardingSlider />

				<div className="section--membership__form" ref={cardFormRef}>
					<div className="section--membership__header u-display--f--col">
						<i className="u-icon u-icon--xlrg u-icon--check-circle u-icon--animated--bounce-in u-color--sent--success" />
						<div className="section--membership__title">
							{t("REGISTRATION_SUCCESS.CONGRATULATIONS")}
						</div>
					</div>

					<div className="section--membership__content section--membership__message">
						<div className="u-mar--bottom--med">
							<div className="u-mar--bottom--med">
								<div className="u-mar--bottom--xsml u-color--text--secondary">
									{t(
										"REGISTRATION_SUCCESS.SUCCESSFULY_CREATED"
									)}
								</div>
								<div className="u-color--text--secondary">
									{t(
										"REGISTRATION_SUCCESS.REGISTRATION_NOTE"
									)}
								</div>
							</div>

							<div className="u-mar--bottom--med">
								<div className="u-mar--bottom--xtny u-type--wgt--bold">
									{t("REGISTRATION_SUCCESS.PLAY_RESPONSIBLY")}
								</div>
								<div className="u-color--text--secondary">
									{t(
										"specific:MEMBERSHIP.RESPONSIBLE_GAMING.MESSAGE"
									)}
								</div>
							</div>

							<div className="u-color--text--secondary">
								{t("REGISTRATION_SUCCESS.WISHES_MESSAGE")}
							</div>
						</div>
					</div>

					<button
						type="button"
						className="at-regSuccessBtn btn btn--base btn--block btn--accent"
						onClick={redirectUserToHomePageAfterRegistration}
					>
						{t("COMMON.BACK_TO_HOME_PAGE")}
					</button>
				</div>
			</div>
		</div>
	);
}
